import { t } from 'i18next';

export const getSceneTags = (
  source: {
    keywords?: string[];
    worldview?: string[];
    totalCount?: number;
    sequenceNo?: number;
  } | null
): string[] => [
  ...(source?.totalCount && source?.sequenceNo
    ? [`${t('SceneMain.part')} ${source.sequenceNo}/${source.totalCount}`]
    : []),
  ...(source?.keywords?.slice(0, 3) ?? []),
  ...(source?.worldview ?? [])
];
